/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `OPEN_AI_ASSISTANT` - OPEN_AI_ASSISTANT
 * * `CELINA` - CELINA
 * @export
 */
export const ConversationalAgentProtocolEnum = {
  openAiAssistant: 'OPEN_AI_ASSISTANT',
  celina: 'CELINA',
} as const;
export type ConversationalAgentProtocolEnum =
  (typeof ConversationalAgentProtocolEnum)[keyof typeof ConversationalAgentProtocolEnum];

export function instanceOfConversationalAgentProtocolEnum(value: any): boolean {
  for (const key in ConversationalAgentProtocolEnum) {
    if (Object.prototype.hasOwnProperty.call(ConversationalAgentProtocolEnum, key)) {
      if ((ConversationalAgentProtocolEnum as Record<string, ConversationalAgentProtocolEnum>)[key] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ConversationalAgentProtocolEnumFromJSON(json: any): ConversationalAgentProtocolEnum {
  return ConversationalAgentProtocolEnumFromJSONTyped(json, false);
}

export function ConversationalAgentProtocolEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ConversationalAgentProtocolEnum {
  return json as ConversationalAgentProtocolEnum;
}

export function ConversationalAgentProtocolEnumToJSON(value?: ConversationalAgentProtocolEnum | null): any {
  return value as any;
}
